module.exports = __webpack_public_path__ + "static/media/icon_notice.082f31e3.svg";